import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AltraParte } from 'src/app/common/models/altraparte';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-step-soggetti-terzi-list-altreparti',
  templateUrl: './step-soggetti-terzi-list-altreparti.component.html',
  styleUrls: ['./step-soggetti-terzi-list-altreparti.component.css']
})
export class StepSoggettiTerziListAltrepartiComponent implements OnInit, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  @Input() associable: boolean;
  @Input() labelComponent: string;
  @Input() action: string;
  soggetti: { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }[] = [];
  @Output() onReturn: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Output() actionEmitter: EventEmitter<string> = new EventEmitter<string>();

  activeIndex: number;
  associationParte: boolean;
  editingParte: boolean;
  parteSelected: AltraParte;

  altreParti: AltraParte[] = [];

  currentTab: String = "ANAGRAFICA";

  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(private operations: OperationsService, private creazionePraticaStoreService: CreazionePraticaStoreService) { }

  ngOnInit() {

    this.creazionePraticaStoreService.soggettoTerzo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(altreParti => {
      if(altreParti){
        this.soggetti = [];
        this.altreParti = altreParti;
        altreParti.forEach(element => {
          let option =  { isAssociated: true, hasDetailsAnagrafica: false, option: element }
          this.soggetti.push(option)
        });
      }
    })

  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  openDetail(option: { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
      this.editingParte = true;
      if (!option.hasDetailsAnagrafica && option.option.parte.id && !option.option.parte.id.startsWith('TEMP')) {
        this.getAnagrafica(option.option.parte).subscribe(response => this.refreshElementInArray(indice, response));
      }
    } else {
      this.editingParte = false;
      this.associationParte = false;
      this.activeIndex = undefined;
      this.parteSelected = undefined;
    }

  }

  private getAnagrafica(option: Parte): Observable<Parte> {
    return this.operations.getAnagrafica(ServicePathsSettings.URL_GET_PARTE, option.id, true);
  }

  private refreshElementInArray(indice: number, element: Parte): { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte } {
    this.soggetti[indice].option.parte = element;
    return this.soggetti[indice];
  }

  retrieveParte(parte: Parte, option: AltraParte) {
    this.parteSelected = option;
    if (parte) {
      this.altreParti = this.altreParti.map(el => {
        if(el === option) el.parte = parte;
        return el;
      });
      this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
      this.creazionePraticaStoreService.save();
      option.parte = parte;
      this.parteSelected = undefined;
    }
  }

  setTab(type: string) {
    this.currentTab = type;
  }

  disassocia(option: AltraParte,) {
    let filtred = this.altreParti.filter(altraparte => altraparte.parte.id !== option.parte.id);
    this.creazionePraticaStoreService.setSoggettiTerzi(filtred);
    this.creazionePraticaStoreService.save();
  }

}
